import { HealthStatus } from '@swyftx/features/loans/components/LoanHealth/api/types/loanHealth.types';

export type HealthConfig = {
  color: 'success' | 'info' | 'warning' | 'error' | 'placeholder';
  statusTitle: string;
};

export const LOAN_HEALTH_CONFIG: Record<HealthStatus, HealthConfig> = {
  [HealthStatus.Healthy]: {
    color: 'success',
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.healthy',
  },
  [HealthStatus.Attention]: {
    color: 'info',
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.attention',
  },
  [HealthStatus.Repayment]: {
    color: 'warning',
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.repayment',
  },
  [HealthStatus.Default]: {
    color: 'error',
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.default',
  },
  [HealthStatus.Inactive]: {
    color: 'placeholder',
    statusTitle: 'N/A',
  },
};
